import { TimelineDraggableSlotProps } from '@modules/timetable';

export const TimelineDraggableSlot = ({ leftOffset, rightOffset, group, slot }: TimelineDraggableSlotProps) => {
  return (
    <div
      key={`${group.id}-${slot.startTime.unix().toString()}`}
      id={slot.startTime.unix().toString()}
      style={{
        left: leftOffset,
        width: rightOffset - leftOffset,
        position: 'absolute',
        height: '100%',
        borderWidth: 0.1,
        borderColor: '#f2f2f2',
        borderStyle: 'inset',
        backgroundColor: 'rgba(255, 0, 0, 0)',
      }}
    />
  );
};
